// Une nombres de clase y descarta lo que no aplica (`false`, `undefined`, cadena vacía).
export function cx(...parts: Array<string | false | null | undefined>): string {
  return parts.filter(Boolean).join(' ');
}

/**
 * Tonos de estado compartidos por `Card` y `Badge`. El nombre dice el significado y el token decide
 * el color: `success` es el verde (reservado para éxito, B0-08), `warning` el durazno, `danger` el
 * rosa, `info` el azul cielo, `accent` el lila y `highlight` el amarillo.
 */
export type Tone = 'info' | 'success' | 'warning' | 'danger' | 'accent' | 'highlight';
